import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { fetchHHContractSignDocumentByClientId } from "../utils/formUtils";
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ContractSignDocumentPopup = ({ open, onClose, clientId }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  // Define initial sort model
  const sortModel = [
    {
      field: "createdAt", // Sort by the FileName column
      sort: "desc", // 'asc' for ascending order, 'desc' for descending
    },
  ];
  // Fetch data when the dialog opens
  useEffect(() => {
    if (open && clientId) {
      setLoading(true);
      fetchHHContractSignDocumentByClientId(clientId)
        .then((data) => {
          const formattedData = data.map((item, index) => ({
            id: index + 1, // Unique ID for DataGrid
            clientId: item.ClientId,
            clientName: item.ClientName,
            subcontractorName: item.SubcontractorName,
            documentTemplateName: item.DocumentTemplateName,
            documentType: item.DocumentType,
            status: item.Status,
            createdAt: item.CreatedAt,
            downloadUrl: item.DownloadUrl,
          }));
          setRows(formattedData);
        })
        .catch((error) => console.error("Error loading data:", error))
        .finally(() => setLoading(false));
    }
  }, [open, clientId]);

  // Define columns for the DataGrid
  const columns = [
    {
      field: "clientName",
      headerName: "Client",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "subcontractorName",
      headerName: "Subcontractor",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "documentTemplateName",
      headerName: "Template Name",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "documentType",
      headerName: "Document Type",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerClassName: "bold-header",
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      headerClassName: "bold-header",
      renderCell: (params) => {
        if (params.value) {
          return dayjs(params.value).format("DD/MM/YYYY");
        }
        return "NA";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box>
          <Tooltip title=" View Contract Sign Documents" arrow>
            <IconButton
              color="primary"
              onClick={() => window.open(params.row.downloadUrl, "_blank")}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold" }}>
        Contract Sign Documents
      </Typography>

      <DialogContent>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 50, 100]}
          disableSelectionOnClick
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          sortModel={sortModel} // Set initial sort model
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContractSignDocumentPopup;
